export class BillingOptionCode {
  public static readonly TYPE_LENS = 'L';
  id: string;
  code: string;
  type: string;
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/data/billing-option-code.ts